<template>
    <div>
        <!-- Alert -->
        <Alert v-if="atype !== ''" :atype="atype" :message="message" :visibility="visibility" />

        <carousel class=""/>

        <Step :step="step" />

        <Loginbar v-if="$store.getters.user_token == ''" />

        <Banner class="" :banner="banner"/>

        <div class="menu-container">

            <Menu :menu="menu"/>

        </div>

        <Banner class="" :banner="bottomBanner"/>

    </div>
</template>

<script>
import Api from "@/api";
import Menu from '@/components/HomePage/Menu';
import Step from '@/components/HomePage/step';
import carousel from '@/components/HomePage/carousel';
import Banner from '@/components/HomePage/Banner';
import Alert from "@/components/Reusable/Alert.vue";
import Loginbar from "@/components/HomePage/Loginbar.vue";

export default {
    name:'Home',
    data() {
        return {
            snackbar: false,
            snackbartitle: '',
            atype: '',
            message: '',
            visibility: '',
            banner: [],
            bottomBanner: [],
            step: null,
            defaultMenu: {
                before: [{
                        name: 'Register',
                        param: 't1_home_body_menu_register',
                        image: "//assets.office4u.xyz/common_asset/menu/Register.png",
                        url: 'Register'
                    },
                    {
                        name: 'Deposit',
                        param: 't1_home_body_menu_deposit',
                        image: "//assets.office4u.xyz/common_asset/menu/Deposit.png",
                        url: 'Game'
                    },
                    {
                        name: 'Games',
                        param: 't1_home_body_menu_games',
                        image: "//assets.office4u.xyz/common_asset/menu/Games.png",
                        url: 'Game'
                    },
                    {
                        name: 'Promotion',
                        param: 't1_home_body_menu_promotion',
                        image: "//assets.office4u.xyz/common_asset/menu/Promotion.png",
                        url: 'Promotion'
                    },
                    {
                        name: 'How to Play',
                        param: 't1_home_body_menu_howtoplay',
                        image: "//assets.office4u.xyz/common_asset/menu/How_2_Play.png",
                        url: 'Play'
                    },
                    {
                        name: 'Contact',
                        param: 't1_home_body_menu_contactus',
                        image: "//assets.office4u.xyz/common_asset/menu/Contact.png",
                        url: 'Contact'
                    }
                ],
                after: [{
                        name: 'VIP',
                        param: 't1_home_body_menu_vip',
                        image: "//assets.office4u.xyz/common_asset/menu/VIP.png",
                        url: 'Coming Soon'
                    },
                    {
                        name: 'Deposit',
                        param: 't1_home_body_menu_deposit',
                        image: "//assets.office4u.xyz/common_asset/menu/Deposit.png",
                        url: 'Game'
                    },
                    {
                        name: 'Games',
                        param: 't1_home_body_menu_games',
                        image: "//assets.office4u.xyz/common_asset/menu/Games.png",
                        url: 'Game'
                    },
                    {
                        name: 'Promotion',
                        param: 't1_home_body_menu_promotion',
                        image: "//assets.office4u.xyz/common_asset/menu/Promotion.png",
                        url: 'Promotion'
                    },
                    {
                        name: 'How to Win',
                        param: 't1_home_body_menu_howtowin',
                        image: "//assets.office4u.xyz/common_asset/menu/How_2_Win.png",
                        url: 'Tips'
                    },
                    {
                        name: 'Download',
                        param: 't1_home_body_menu_download',
                        image: "//assets.office4u.xyz/common_asset/menu/Download.png",
                        url: 'Download Link'
                    },
                    {
                        name: 'Mini Game',
                        param: 't1_home_body_menu_minigame',
                        image: "//assets.office4u.xyz/common_asset/menu/Mini_Game.png",
                        url: 'Mini Game'
                    }]
            },
            defaultMenuImg: {
                'Register': "//assets.office4u.xyz/common_asset/menu/Register.png",
                'Deposit': "//assets.office4u.xyz/common_asset/menu/Deposit.png",
                'Withdraw': "//assets.office4u.xyz/common_asset/menu/Withdraw.png",
                'VIP': "//assets.office4u.xyz/common_asset/menu/VIP.png",
                'Games': "//assets.office4u.xyz/common_asset/menu/Games.png",
                'Promotion': "//assets.office4u.xyz/common_asset/menu/Promotion.png",
                'Contact': "//assets.office4u.xyz/common_asset/menu/Contact.png",
                'How to Play': "//assets.office4u.xyz/common_asset/menu/How_2_Play.png",
                'How to Win': "//assets.office4u.xyz/common_asset/menu/How_2_Win.png",
                'Download': "//assets.office4u.xyz/common_asset/menu/Download.png",
                'Mini Game': "//assets.office4u.xyz/common_asset/menu/Mini_Game.png",
            },
            menu: null
        }
    },
    components: {
        Menu,
        carousel,
        Alert,
        Banner,
        Step,
        Loginbar
    },
    mounted: function() {

        if (this.$store.getters.registration_flag) {

            this.$store.commit('toggleRegistrationFlag', false);

            this.message = this.$t( 'register_success' );

            this.atype = "success";

            this.visibility = true;

        }

        this.getBodyAsset();

    },
    methods: {
        async getBodyAsset() {

            let res = await Api.getBodyAsset();

            if (res && res['data']) {

                if(res['data']['banner']) {

                    this.banner = res['data']['banner'].map(function(banner){

                        return banner.value;

                    });

                }

                //Bottom Banner

                 if(res['data']['bottomBanner']) {

                    this.bottomBanner = res['data']['bottomBanner'].map(function(banner){

                        return banner.value;

                    });

                }

                if(res['data']['step']) {

                    this.step = res['data']['step']['value'];

                }

                if(res['data']['menu']) {

                    let currentInstance = this;

                    let defaultMenuImgs = currentInstance.defaultMenuImg;

                    let before = [];

                    let after = [];

                    if(res['data']['menu']['before']) {

                        before = res['data']['menu']['before'].map(function(menu) {

                            let img = '';

                            if(menu.image) {

                                img = menu.image;

                            } else {

                                if(defaultMenuImgs[menu.menu.name]) {

                                    img = defaultMenuImgs[menu.menu.name];

                                }
                            }

                            return {
                                name: menu.menu? menu.menu.name : 'Unknown',
                                url: menu.menu? menu.menu.route : 'Coming Soon',
                                image: img
                            };

                        });
                    }

                    if(res['data']['menu']['after']) {

                        after = res['data']['menu']['after'].map(function(menu){

                             let img = '';

                            if(menu.image) {

                                img = menu.image;

                            } else {

                                if(defaultMenuImgs[menu.menu.name]) {

                                    img = defaultMenuImgs[menu.menu.name];

                                }

                            }

                            return {
                                name: menu.menu? menu.menu.name : 'Unknown',
                                url: menu.menu? menu.menu.route : 'Coming Soon',
                                image: img
                            };

                        });

                    }

                    currentInstance.menu = {
                        'before': before,
                        'after': after
                    };
                }
            }
        }
    }
}
</script>

